export const HEX_REGEXP = /^#[0-9a-f]{6}$/i;
